import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RequestsService } from '../requests.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface Settings{
  comisionFianzaPorcentaje: number;
  defaultInterestPercentage: number;
  lastChangeDate: string;
  maximumInterestPercentage: number;
  maximumLateInterestPercentage: number;
}

@Component({
  selector: 'app-credit-modal',
  templateUrl: './credit-modal.component.html',
  styleUrls: ['./credit-modal.component.scss'],
})
export class CreditModalComponent {
  @Input() show = false;
  @Output() close = new EventEmitter<void>();

  form!: FormGroup | UntypedFormGroup;
  valorCredito: number = 0;
  plazo: number = 12;
  interes: number = 3;
  fianza: number = 25;
  firmas: number = 1;
  cuotaMensual: number | null = null;
  totalPagado: number | null = null;
  settings: Settings;

  constructor(
    private fb: FormBuilder,
    public service: RequestsService,
    private ref: MatDialogRef<CreditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.show = data;
    this.getSettings();
    this.form = this.fb.group({
      valorCredito: [this.valorCredito, [Validators.required]],
      plazo: [this.plazo, [Validators.required, Validators.min(1), Validators.max(24)]],
      interes: [this.interes, [Validators.required]],
      fianza: [this.fianza, [Validators.required]],
      firmas: [this.firmas, [Validators.required]]
    });
  }

  calcularCuotas() {
    if (this.form.invalid) {
      return;
    }
    //console.log(this.form.value);
    this.form.value.valorCredito = +this.form.value.valorCredito.replace(/,/g, "");
    
    const montoTotal = this.form.value.valorCredito + (this.form.value.firmas * 45000) + ((this.form.value.valorCredito * (this.form.value.fianza/100)) * 1.19);
    const tasaMensual = this.form.value.interes / 100;
    const n = this.form.value.plazo;

    if (tasaMensual === 0) {
      this.cuotaMensual = montoTotal / n;
    } else {
      this.cuotaMensual =
        (montoTotal * tasaMensual) / (1 - Math.pow(1 + tasaMensual, -n));
    }

    this.totalPagado = this.cuotaMensual * n;
  }

  cerrar() {
    this.closet();
    this.close.emit();
  }

  closet(): void { this.ref.close(); }

   formatNumberAsValue($input: HTMLInputElement){
    return parseFloat($input.value.replace(/[^0-9]/g, '')).toLocaleString('en-US')
  }

  onDocumentNumberInput(event: Event,controlador): void {
    const input = event.target as HTMLInputElement;
    this.valorCredito = parseFloat(input.value.replace(/[^0-9]/g, ''));
    input.value = this.formatNumberAsValue(input);
  }

  getSettings(){
    this.service.getSettings().subscribe(resp => {
      this.settings = resp;
      //console.log(this.settings);
    })
  }
}
